import apiClient from 'utilities/apiClient';

export const document = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.document}/${url}`, payload, true);
};

export const create_batch = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.batch}/${url}`, payload, true);
};

export const get_focus_mrn = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.purchase}/${url}`, payload, true);
};
